export const DOMAIN_HEADER =
  'Set up a new domain: Rackspace DNS, our site alias and its certificates, run in the right order for the site type.';

export interface DomainOption {
  label: string;
  value: string;
}

export const DOMAIN_OPTIONS: DomainOption[] = [
  { label: 'Office', value: 'Office' },
  { label: 'Agent', value: 'Agent' },
  { label: 'Broker', value: 'Broker' },
  { label: 'Team', value: 'Team' },
];

/**
 * What one site type runs. `job` is the service's domain-setup job; `dns` is the /dns/config
 * site type for the customer's root A + www (or *.) CNAME, written after the job succeeds.
 * Office has no `dns`: its job writes the whole zone.
 */
export interface SitePlan {
  job?: 'clientBay' | 'sitesBay.agent' | 'sitesBay.broker';
  dns?: 'A' | 'B' | 'T';
  summary: string;
}

export const SITE_PLANS: Record<string, SitePlan> = {
  Office: {
    job: 'clientBay',
    summary:
      'Creates the zone (www, root, SendGrid SPF, DMARC and MX) and the office certificates.',
  },
  Agent: {
    job: 'sitesBay.agent',
    dns: 'A',
    summary: 'Creates our site alias and certificates, then the customer root A and www CNAME.',
  },
  Broker: {
    job: 'sitesBay.broker',
    dns: 'B',
    summary: 'Creates our site alias and root certificate, then the customer root A and *. CNAME.',
  },
  Team: { dns: 'T', summary: 'Writes the customer root A and www CNAME. No certificates.' },
};
